import { render } from "./BovineHistoryCard.vue?vue&type=template&id=f89fdb12&scoped=true"
import script from "./BovineHistoryCard.vue?vue&type=script&lang=js"
export * from "./BovineHistoryCard.vue?vue&type=script&lang=js"

import "./BovineHistoryCard.vue?vue&type=style&index=0&id=f89fdb12&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f89fdb12"]])

export default __exports__